import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { safeLocalStorage } from '@common/utils/storage';

let echoInstance: Echo<'reverb'> | null = null;

export const getEchoInstance = (): Echo<'reverb'> | null => {
  if (!process.env.NEXT_PUBLIC_REVERB_APP_KEY) {
    console.warn('Reverb app key is not configured. WebSocket features are disabled.');
    return null;
  }

  if (process.env.NEXT_PUBLIC_ENABLE_WS !== 'true') {
    return null;
  }

  if (echoInstance) {
    return echoInstance;
  }

  const authToken = safeLocalStorage.getItem('authToken');

  if (!authToken) {
    console.warn('Auth token not found. WebSocket connection requires authentication.');
    return null;
  }

  try {
    window.Pusher = Pusher;

    echoInstance = new Echo<'reverb'>({
      broadcaster: 'reverb',
      authEndpoint: process.env.NEXT_PUBLIC_API_URL + '/broadcasting/auth',
      key: process.env.NEXT_PUBLIC_REVERB_APP_KEY,
      wsHost: process.env.NEXT_PUBLIC_REVERB_HOST,
      wsPort: parseInt(process.env.NEXT_PUBLIC_REVERB_WS_PORT ?? '8080'),
      wssPort: parseInt(process.env.NEXT_PUBLIC_REVERB_WSS_PORT ?? '8080'),
      forceTLS: process.env.NEXT_PUBLIC_REVERB_SCHEME === 'https',
      enabledTransports: ['ws', 'wss'],
      auth: {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      },
    });

    return echoInstance;
  } catch (error) {
    console.error('Failed to initialize Echo/Pusher:', error);
    return null;
  }
};

export const resetEchoInstance = (): void => {
  if (echoInstance) {
    echoInstance.disconnect();
  }
  echoInstance = null;
};
